import { useRef, useEffect, useState } from "react";
import { Eraser, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

export function SignaturePad({ onSave }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#263871";

    const pos = (e) => {
      const r = canvas.getBoundingClientRect();
      const t = e.touches ? e.touches[0] : e;
      return { x: (t.clientX - r.left) * (canvas.width / r.width), y: (t.clientY - r.top) * (canvas.height / r.height) };
    };
    const start = (e) => { e.preventDefault(); drawing.current = true; const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); };
    const move = (e) => { if (!drawing.current) return; e.preventDefault(); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); setEmpty(false); };
    const end = () => { drawing.current = false; };

    canvas.addEventListener("mousedown", start);
    canvas.addEventListener("mousemove", move);
    window.addEventListener("mouseup", end);
    canvas.addEventListener("touchstart", start, { passive: false });
    canvas.addEventListener("touchmove", move, { passive: false });
    window.addEventListener("touchend", end);
    return () => {
      canvas.removeEventListener("mousedown", start);
      canvas.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", end);
      canvas.removeEventListener("touchstart", start);
      canvas.removeEventListener("touchmove", move);
      window.removeEventListener("touchend", end);
    };
  }, []);

  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
  };
  const save = () => { if (!empty) onSave(canvasRef.current.toDataURL("image/png")); };

  return (
    <div>
      <canvas ref={canvasRef} width={480} height={200} data-testid="signature-canvas" className="h-[200px] w-full touch-none rounded-xl border-2 border-dashed border-slate-300 bg-white" />
      <p className="mt-1 text-center text-xs text-slate-400">Signez avec le doigt ou la souris</p>
      <div className="mt-3 flex gap-2">
        <Button type="button" variant="outline" onClick={clear} data-testid="signature-clear" className="rounded-full"><Eraser className="mr-1 h-4 w-4" />Effacer</Button>
        <Button type="button" onClick={save} disabled={empty} data-testid="signature-save" className="flex-1 rounded-full bg-[#263871] hover:bg-[#35508F]"><Check className="mr-1 h-4 w-4" />Valider la signature</Button>
      </div>
    </div>
  );
}
